import React from 'react';
import { Link } from 'react-router-dom';
import {FaBuilding} from 'react-icons/fa';
import './SchoolDashboard.css';

function SchoolDashboard() {
    return (
        <div className="dashboard-container">
            <h2 className="dashboard-title">Rektorat-Dashboard</h2>
            <div className="dashboard-links">
                <Link to="/mdb/school/overview" className="dashboard-link">
                    <FaBuilding className="icon" />
                    Übersicht der Mitverwendungen
                </Link>
            </div>
        </div>
    );
}

export default SchoolDashboard;

